export const getFullLanguage = lang => {
  switch (lang) {
    case 'en':
      return 'EngService';
    case 'ja':
      return 'JpnService';
    case 'zh-CN':
      return 'ChsService';
    default:
      return 'EngService';
  }
};

export const splitTitle = (title, type, lang) => {
  if (title) {
    // 영어일때랑 괄호 문자가 다른문자임
    if (lang === 'ja') {
      // 일본어 일때 : （） 중국어 : ()
      const splited = title.split('（');
      if (splited.length > 2) {
        const sub1 = splited[splited.length - 2]
          ? splited[splited.length - 2].replace(/）/g, '\r\n')
          : '';
        const sub2 = splited[splited.length - 1].replace(/）/g, '\r\n');
        return type === 'sub' ? sub1 + sub2 : splited[0];
      } else if (splited.length === 1) {
        const splited = title.split('(');
        if (splited.length !== 2) {
          const sub1 = splited[splited.length - 2]
            ? splited[splited.length - 2].replace(/\)/g, '\r\n')
            : '';
          const sub2 = splited[splited.length - 1].replace(/\)/g, '\r\n');
          return type === 'sub' ? sub1 + sub2 : splited[0];
        } else {
          return type === 'sub'
            ? splited[1].replace(/\)/g, '\r\n')
            : splited[0];
        }
      } else {
        return type === 'sub' ? splited[1].replace(/）/g, '\r\n') : splited[0];
      }
    } else {
      const splited = title.split('(');
      if (splited.length !== 2) {
        const sub1 = splited[splited.length - 2]
          ? splited[splited.length - 2].replace(/\)/g, '\r\n')
          : '';
        const sub2 = splited[splited.length - 1].replace(/\)/g, '\r\n');
        return type === 'sub' ? sub1 + sub2 : splited[0];
      } else {
        return type === 'sub' ? splited[1].replace(/\)/g, '\r\n') : splited[0];
      }
    }
  }
};

export const translate = (word, lang) => {
  const locale = {
    all: {
      en: 'All',
      ja: 'すべて',
      [`zh-CN`]: '所有',
    },
    tour: {
      en: 'Tour',
      ja: 'ツアー',
      [`zh-CN`]: '游览',
    },
    culture: {
      en: 'Culture',
      ja: '文化',
      [`zh-CN`]: '文化',
    },
    store: {
      en: 'Store',
      ja: '格納',
      [`zh-CN`]: '商店',
    },
  };
  return locale[word][lang];
};

export const httpToS = url => {
  return url.replace('http', 'https');
};
